import { createContext, useState, useContext, useEffect } from "react";

// Criar o contexto
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(localStorage.getItem("selectedTheme") || "lara-light-blue");

    useEffect(() => {
        changeTheme(theme);
    }, [theme]);
    

    const changeTheme = (newTheme) => {
        let link = document.getElementById('theme-link');
        if (!link) {
            link = document.createElement('link');
            link.id = 'theme-link';
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }
        link.href = `https://unpkg.com/primereact/resources/themes/${newTheme}/theme.css`;
        localStorage.setItem("selectedTheme", newTheme);
        setTheme(newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, changeTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

// Hook para usar o tema em qualquer componente
export const useTheme = () => useContext(ThemeContext);
